<template>
  <!-- TODO: test min-height: 174px in RESOL config -->
  <v-content
    style="min-height:145px;"
    :class="{'nav-bottom': true, 'static-header': false}"
    v-if="!shortHeader && showNavBottom"
  >
    <v-container>
      <v-flex style="padding-left: 0px!important;">
        <v-content
          v-if="$VENDOR === 'mtf'"
          class="mt-3 text-xs-left"
        >
          <a href="/#/">
            <div class="logo">
              <img src="static/images/mtf-samsung.svg" alt="Logo" class="logo-image-mtf" :height="imageHeight + 20">
              <!-- <div class="logo-text-mtf primary--text">DVM Cloud</div> -->
            </div>
          </a>
        </v-content>
        <v-content
          v-else
          class="mt-3 text-xs-left"
        >
          <a href="/#/" v-if="!storeUser">
            <div class="logo">
              <img src="static/images/VBus_net_Only_Logo.png" alt="Logo" class="logo-image" :height="imageHeight">
              <div class="logo-text">VBus.net</div>
            </div>
          </a>
          <a href="/#/" v-else>
            <div class="logo hidden-xs-only">
              <img src="static/images/VBus_net_Only_Logo.png" alt="Logo" class="logo-image" :height="imageHeight">
              <div class="logo-text">VBus.net</div>
              <div class="logo-pro" v-if="storeUser.isProfessional">PRO</div>
            </div>
            <div class="logo-sm hidden-sm-and-up">
              <img src="static/images/VBus_net_Only_Logo.png" alt="Logo" class="logo-sm-image" :height="imageHeight">
              <div class="logo-sm-text">VBus.net</div>
              <div class="logo-sm-pro" v-if="storeUser.isProfessional">PRO</div>
            </div>
          </a>
          <div class="alternative-font myHeadline" :style="($vuetify.breakpoint.name !== 'xs') ? 'font-size :26px;overflow-wrap:normal;clear:both' : 'clear:both'">
            {{ $t('general.indexPortal') }}
            <span
              v-if="$environment === 'development' && storeUser && storeUser.isAdmin"
              class="branch-info"
              :style="`background-color:${getBranch(storeUser.gitCommit).color}`"
            >
              {{ getBranch(storeUser.gitCommit).text }}
            </span>
            <v-alert
              v-if="storeConfiguration && storeConfiguration.show_global_error_message === '1'"
              :value="true"
              type="error"
              class="mt-3"
            >
              <p class="headline white--text">{{ $t('general.globalErrorTitle') }}</p>
              <p class="title white--text">{{ $t('general.globalErrorMessage') }}</p>
            </v-alert>
            <v-alert
              v-if="storeConfiguration && storeConfiguration.show_global_success_message === '1'"
              :dismissible="true"
              :value="true"
              icon="info"
              type="success"
              class="mt-3"
            >
              <p class="title white--text">{{ $t('general.globalSuccessTitle') }}</p>
              <p class="subheading white--text">{{ $t('general.globalSuccessMessage') }}</p>
              <p class="subheading white--text"><a href="/#/faq/3" style="text-decoration:underline;color:white!important">{{ this.$t('faq.q3') }}</a></p>
            </v-alert>
          </div>
        </v-content>

        <v-toolbar dense flat>
          <v-toolbar-title
            v-if="$VENDOR === 'mtf'"
            class="logo-text-mtf primary--text"
          >
            DVM Cloud Service
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items
            v-if="storeUser && !validProAccount && $VENDOR === 'resol'"
          >
            <v-btn
              @click="orderPRO = true"
              color="primary"
              flat
            >
              <v-icon class="mr-1">star</v-icon>
              <span v-if="!$vuetify.breakpoint.smAndDown">
                {{ $t('get.professional.account') }}
              </span>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-side-icon
            v-if="!maintenance"
            class="hidden-md-and-up"
            style="color:#696969"
            @click.native="toggleDrawer"
          ></v-toolbar-side-icon>
        </v-toolbar>

        <v-dialog v-model="orderPRO" max-width="680px">
          <payment
            todo="read-user-to-store"
            v-if="orderPRO"
            :user="$store.state.user"
            :account="accountInfo"
            @closeOrderProDialog="closeOrderProDialog"
          ></payment>
        </v-dialog>
      </v-flex>
      <!-- <v-alert
        :value="true"
        type="info"
        class="pa-1"
      >
        <v-layout class="text-xs-left" style="color:#696969;">
          <v-flex xs12>
            <p class="headline mb-1">Wartungsarbeiten!</p>
            <p class="mb-0 mr-3">Aufgrund geplanter Wartungsarbeiten wird VBus.net am <strong>26.09.2023 zwischen 08:00 Uhr - 10:00 Uhr (MEZ)</strong> nur eingeschränkt verfügbar sein!</p>
          </v-flex>
          <v-flex xs12>
            <p class="headline mb-1">Down for Maintenance!</p>
            <p class="mb-0">Due to planned maintenance work, VBus.net will only have limited availability on <strong>September 26th, 2023 between 08:00 a.m. and 10:00 a.m. (CET)!</strong></p>
          </v-flex>
        </v-layout>
      </v-alert> -->
    </v-container>

  </v-content>
</template>

<script>
import { mapGetters } from 'vuex'
import account from '@/client/lib/account'
const Payment = () => import('@/client/components/Payment')

export default {
  props: {
    shortHeader: {
      type: Boolean
    },
    showNavBottom: {
      type: Boolean
    },
    staticNavbar: {
      type: Boolean
    },
    maintenance: {
      type: Boolean
    }
  },
  components: {
    Payment
  },
  data () {
    return {
      orderPRO: false,
      imageHeight: 46
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.name === 'xs') {
      this.imageHeight = 32
    }
  },
  computed: {
    ...mapGetters([
      'storeUser',
      'storeConfiguration'
    ]),
    accountInfo: function () {
      if (this.$store.state.user) {
        return account.info(this.$store.state.user.subscription, this.$store.state.user.subscription_valid_until)
      }
    },
    validProAccount: function () {
      return (this.$store.state.user) ? this.$store.state.user.isProfessional : false
    }
  },
  methods: {
    closeOrderProDialog () {
      this.orderPRO = false
    },
    toggleDrawer () {
      this.$store.commit('setDrawer', true)
    },
    getBranch (cmd) {
      let result = null
      let color = '#f5f5f2'
      if (cmd) {
        const tmp = cmd.split(';')
        if (tmp && tmp.length > 0) {
          result = tmp[0]
          if (result.indexOf('feature') >= 0) {
            color = '#f840b5'
          } else if (result.indexOf('develop') >= 0) {
            color = '#fee13d'
          } else if (result.indexOf('release') >= 0) {
            color = '#5bc22d'
          } else if (result.indexOf('hotfix') >= 0) {
            color = '#fb5966'
          } else if (result.indexOf('master') >= 0) {
            color = '#33e5f8'
          }
        }
      }
      return {
        text: result,
        color: color
      }
    }
  }
}
</script>

<style>
.v-toolbar__content {
  padding-left: 0px;
}
</style>

<style scoped>
.myHeadline {
  color:#696969;
  font-weight: 100!important;
}
.nav-bottom {
  height: auto;
  background-color: #f5f5f2;
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-top: 20px;
  border-bottom: 1px solid #D6D6D0!important;
}
.logo {
  position: relative;
  min-height: 38px;
}
.logo-sm {
  position: relative;
  min-height: 28px;
}
.logo-image {
  float: left;
  position: absolute;
  bottom: 0;
}
.logo-image-mtf {
  float: left;
  position: absolute;
  bottom: 0;
}
.logo-sm-image {
  float: left;
  position: absolute;
  bottom: 0;
  height: 30px;
}
.logo-text {
  font-family: "Open Sans Regular", sans-serif !important;
  vertical-align: bottom;
  font-size: 40px;
  font-weight: 500;
  color: #69a341;
  padding: 0px;
  float: left;
  position: absolute;
  top: -7px;
  left: 63px;
}
.logo-text-mtf {
  font-family: "Open Sans Regular", sans-serif !important;
  font-size: 36px;
  font-weight: 550;
}
.logo-sm-text {
  font-family: "Open Sans Regular", sans-serif !important;
  vertical-align: bottom;
  font-size: 30px;
  font-weight: 500;
  color: #69a341;
  padding: 0px;
  float: left;
  position: absolute;
  top: -6px;
  left: 44px;
}
.logo-pro {
  width: 33px;
  height: 20px;
  background-color: #696969;
  border-radius: 4px 4px 4px 4px;
  -moz-border-radius: 4px 4px 4px 4px;
  -webkit-border-radius: 4px 4px 4px 4px;
  color: white;
  font-size: 12px;
  padding: 4px;
  padding-top: 1px;
  padding-left: 5px;
  float: left;
  margin-left: 8px;
  position: absolute;
  bottom: 0px;
  left: 224px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.logo-sm-pro {
  width: 30px;
  height: 17px;
  background-color: #696969;
  border-radius: 4px 4px 4px 4px;
  -moz-border-radius: 4px 4px 4px 4px;
  -webkit-border-radius: 4px 4px 4px 4px;
  color: white;
  font-size: 10px;
  padding: 4px;
  padding-top: 1px;
  padding-left: 5px;
  float: left;
  margin-left: 8px;
  position: absolute;
  bottom: 2px;
  left: 168px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.static-header {
  background-color: orange;
  position: fixed;
  top: 38px;
  z-index: 999;
}
.branch-info {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  color: black;
  font-weight: 400;
  font-size: 18px;
  border-radius: 4px 4px 4px 4px;
  -moz-border-radius: 4px 4px 4px 4px;
  -webkit-border-radius: 4px 4px 4px 4px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/client/components/Navigation/Bottom.vue